import { rfimsMeasuredRanges } from './historyProvenance';

export const historyWindowMs = (days: number) =>
  (days <= 2 ? 5 : days <= 7 ? 30 : days <= 31 ? 120 : 360) * 60_000;

/** Summarises returned data, not device availability or unobserved events. */
export function measuredHistorySummary(points: readonly { t: number; v: number }[], days: number) {
  const ordered = points
    .filter((p) => Number.isFinite(p.t) && Number.isFinite(p.v))
    .slice()
    .sort((a, b) => a.t - b.t);
  const windowMs = historyWindowMs(days);
  const gaps: { start: number; end: number; durationMs: number }[] = [];
  let observedChanges = 0;
  for (let i = 1; i < ordered.length; i++) {
    const previous = ordered[i - 1],
      current = ordered[i];
    const ranges = rfimsMeasuredRanges(previous.t, current.t);
    const excluded = ranges.reduce((sum, r) => sum + r.end - r.start, 0) < current.t - previous.t;
    if (!excluded && current.t - previous.t <= windowMs * 1.5 && previous.v !== current.v) observedChanges++;
    if (current.t - previous.t > windowMs * 1.5)
      for (const range of rfimsMeasuredRanges(previous.t + windowMs, current.t - windowMs))
        if (range.end > range.start)
          gaps.push({ start: range.start, end: range.end, durationMs: range.end - range.start });
  }
  return {
    count: ordered.length,
    first: ordered[0]?.t,
    last: ordered.at(-1)?.t,
    min: ordered.length ? Math.min(...ordered.map((p) => p.v)) : null,
    max: ordered.length ? Math.max(...ordered.map((p) => p.v)) : null,
    gaps,
    observedChanges,
  };
}
